import { Component } from '@angular/core'

import { BaseComponent } from '../../shared'

interface CountByLabel {
    label: string
    count: number
}

interface VistaUploadDashboardMetrics {
    totalUploads: number
    inProgress: number
    succeeded: number
    failed: number
    timedOut: number
    last30DaysCount: number
    readyToAcceptInVista: number
    byRecordType: CountByLabel[]
    byStatus: CountByLabel[]
}

const emptyMetrics = (): VistaUploadDashboardMetrics => ({
    totalUploads: 0,
    inProgress: 0,
    succeeded: 0,
    failed: 0,
    timedOut: 0,
    last30DaysCount: 0,
    readyToAcceptInVista: 0,
    byRecordType: [],
    byStatus: [],
})

@Component({
    selector: 'app-vista-uploads-dashboard',
    templateUrl: './vista-uploads-dashboard.component.html',
    standalone: true,
    imports: [],
})
export class VistaUploadsDashboardComponent extends BaseComponent {
    metrics: VistaUploadDashboardMetrics = emptyMetrics()
    metricsLoadError = false

    constructor() {
        super()
        this.refresh()
    }

    refresh() {
        this.cancelableRequest(
            'vistaUploadsDashboard',
            true,
            this.services.data.get<VistaUploadDashboardMetrics>('/api/VistaBatchImport/GetDashboardMetrics').subscribe({
                next: result => {
                    this.metrics = result ?? emptyMetrics()
                    this.metricsLoadError = false
                    this.initialLoadingComplete()
                },
                error: () => {
                    this.metrics = emptyMetrics()
                    this.metricsLoadError = true
                    this.initialLoadingComplete()
                },
            }),
        )
    }

    maxRecordTypeCount(): number {
        return Math.max(...this.metrics.byRecordType.map(x => x.count), 1)
    }
}
